import styled from "styled-components";
import { colors } from "../utils/Colors";
import { useTranslation } from "react-i18next";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";
import { IoMdInformation, IoMdClose } from "react-icons/io";
import useEmblaCarousel from "embla-carousel-react";
import { useEffect, useState } from "react";

const projectImages = {
  creasprint: Array.from(
    { length: 9 },
    (_, i) => `/projects/creasprint/creasprint-shot-${i + 1}.png`,
  ),
  neocollege: [
    "/projects/neocollege/admin-cartre-credit-800x380.png",
    "/projects/neocollege/carte-credit-activite-neo-college-800x380.png",
    "/projects/neocollege/carte-credit-admin-new-800x380.png",
    "/projects/neocollege/couleurs-admin-800x394.png",
    "/projects/neocollege/Design-sans-titre-3-800x380.png",
    "/projects/neocollege/oanh-utilisatrice-point-800x380.png",
  ],
  sexualis: [
    "/projects/sexualis/screen-1.png",
    "/projects/sexualis/2-Complete.png",
    "/projects/sexualis/3-complete.png",
    "/projects/sexualis/4-complete.png",
    "/projects/sexualis/5-complete.png",
    "/projects/sexualis/6-complete.png",
    "/projects/sexualis/7-complete.png",
    "/projects/sexualis/8-complete.png",
    "/projects/sexualis/9-complete.png",
  ],
};

const Projects = () => {
  const [overlay, setOverlay] = useState("");
  const [selectedIndex, setSelectedIndex] = useState(1);
  const [modal, setModal] = useState({ images: [], index: 0 });
  const { t } = useTranslation();

  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: false,
    align: "center",
    startIndex: 1,
    containScroll: false,
  });

  useEffect(() => {
    if (!emblaApi) return;
    const onSelect = () => {
      setSelectedIndex(emblaApi.selectedScrollSnap());
      setOverlay("");
    };
    emblaApi.on("select", onSelect);
    return () => emblaApi.off("select", onSelect);
  }, [emblaApi]);

  useEffect(() => {
    if (modal.images.length > 0) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [modal.images.length]);

  const openModal = (images) => setModal({ images, index: 0 });
  const closeModal = () => setModal({ images: [], index: 0 });
  const prevImage = (e) => {
    e.stopPropagation();
    setModal((prev) => ({
      ...prev,
      index: (prev.index - 1 + prev.images.length) % prev.images.length,
    }));
  };
  const nextImage = (e) => {
    e.stopPropagation();
    setModal((prev) => ({
      ...prev,
      index: (prev.index + 1) % prev.images.length,
    }));
  };

  const handleClickSlide = (index, slideId) => {
    if (!emblaApi) return;
    if (emblaApi.selectedScrollSnap() !== index) {
      emblaApi.scrollTo(index);
    } else {
      setOverlay((prev) => (prev === slideId ? "" : slideId));
    }
  };

  const handleOverlay = (e, slide) => {
    e.stopPropagation();
    setOverlay((prev) => (prev === slide ? "" : slide));
  };

  return (
    <MainContainer id="projects">
      <img
        src="/AboutWave.svg"
        alt="Wave About"
        style={{ position: "absolute", bottom: "0px", left: 0, zIndex: -1 }}
      />
      <Container>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <ContainerTitle>
            <H1>{t("projects.title")}</H1>
            <LineTitle />
          </ContainerTitle>
          <ContainerArrow>
            <ContainerArrowLeft
              onClick={() => {
                setOverlay("");
                emblaApi?.scrollPrev();
              }}
            >
              <AiOutlineArrowLeft />
            </ContainerArrowLeft>
            <ContainerArrowRight
              onClick={() => {
                setOverlay("");
                emblaApi?.scrollNext();
              }}
            >
              <AiOutlineArrowRight />
            </ContainerArrowRight>
          </ContainerArrow>
        </div>
      </Container>

      {/* EMBLA CAROUSEL */}
      <EmblaViewport ref={emblaRef}>
        <EmblaContainer>
          {/* BeatMi */}
          <EmblaSlide
            isActive={selectedIndex === 0}
            hasOverlay={overlay === "beatmi"}
            onClick={() => handleClickSlide(0, "beatmi")}
          >
            <MoreInfoButton onClick={(e) => handleOverlay(e, "beatmi")}>
              {overlay === "beatmi" ? (
                <IoMdClose size={32} />
              ) : (
                <IoMdInformation />
              )}
            </MoreInfoButton>
            {overlay === "beatmi" && (
              <Overlay>
                <ContainerDescription>
                  <p>{t("projects.beatmi.description")}</p>
                </ContainerDescription>
                <ContainerLink>
                  <button
                    onClick={() =>
                      window.open("https://www.beatmi.com", "_blank")
                    }
                  >
                    {t("projects.live")}
                  </button>
                  <button
                    onClick={() =>
                      window.open(
                        "https://github.com/FabienD0/FinalProject-BeatMi",
                        "_blank",
                      )
                    }
                  >
                    {t("projects.github")}
                  </button>
                  <button
                    onClick={() =>
                      window.open(
                        "https://vimeo.com/manage/videos/822198682",
                        "_blank",
                      )
                    }
                  >
                    {t("projects.demo")}
                  </button>
                </ContainerLink>
              </Overlay>
            )}
            <img src="/cardBeatmi.png" alt="BeatMi Card" />
          </EmblaSlide>

          {/* SEXUALIS */}
          <EmblaSlide
            isActive={selectedIndex === 1}
            hasOverlay={overlay === "sexualis"}
            onClick={() => handleClickSlide(1, "sexualis")}
          >
            <MoreInfoButton onClick={(e) => handleOverlay(e, "sexualis")}>
              {overlay === "sexualis" ? (
                <IoMdClose size={32} />
              ) : (
                <IoMdInformation />
              )}
            </MoreInfoButton>
            {overlay === "sexualis" && (
              <Overlay>
                <ContainerDescription>
                  <p>{t("projects.sexualis.description")}</p>
                </ContainerDescription>
                <ContainerLink>
                  <button
                    onClick={() =>
                      window.open("https://app.sexualis.com", "_blank")
                    }
                  >
                    {t("projects.live")}
                  </button>
                  <button
                    onClick={() =>
                      window.open(t("projects.sexualis.studyCaseUrl"), "_blank")
                    }
                  >
                    {t("projects.studyCase")}
                  </button>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      openModal(projectImages.sexualis);
                    }}
                  >
                    {t("projects.screenshots")}
                  </button>
                </ContainerLink>
              </Overlay>
            )}
            <img src="/cardSexualis.png" alt="Sexualis Card" />
          </EmblaSlide>

          {/* CREASPRINT */}
          <EmblaSlide
            isActive={selectedIndex === 2}
            hasOverlay={overlay === "creasprint"}
            onClick={() => handleClickSlide(2, "creasprint")}
          >
            <MoreInfoButton onClick={(e) => handleOverlay(e, "creasprint")}>
              {overlay === "creasprint" ? (
                <IoMdClose size={32} />
              ) : (
                <IoMdInformation />
              )}
            </MoreInfoButton>
            {overlay === "creasprint" && (
              <Overlay>
                <ContainerDescription>
                  <p>{t("projects.creasprint.description")}</p>
                </ContainerDescription>
                <ContainerLink>
                  <button
                    onClick={() =>
                      window.open("https://app.creasprint.com", "_blank")
                    }
                  >
                    {t("projects.live")}
                  </button>
                  <button
                    onClick={() =>
                      window.open(
                        t("projects.creasprint.studyCaseUrl"),
                        "_blank",
                      )
                    }
                  >
                    {t("projects.studyCase")}
                  </button>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      openModal(projectImages.creasprint);
                    }}
                  >
                    {t("projects.screenshots")}
                  </button>
                </ContainerLink>
              </Overlay>
            )}
            <img src="/cardCreasprint.png" alt="Creasprint Card" />
          </EmblaSlide>

          {/* NeoCollege */}
          <EmblaSlide
            isActive={selectedIndex === 3}
            hasOverlay={overlay === "neocollege"}
            onClick={() => handleClickSlide(3, "neocollege")}
          >
            <MoreInfoButton onClick={(e) => handleOverlay(e, "neocollege")}>
              {overlay === "neocollege" ? (
                <IoMdClose size={32} />
              ) : (
                <IoMdInformation />
              )}
            </MoreInfoButton>
            {overlay === "neocollege" && (
              <Overlay>
                <ContainerDescription>
                  <p>{t("projects.neocollege.description")}</p>
                </ContainerDescription>
                <ContainerLink>
                  <button
                    onClick={() =>
                      window.open("https://app.neocollege.ca", "_blank")
                    }
                  >
                    {t("projects.live")}
                  </button>
                  <button
                    onClick={() =>
                      window.open(
                        t("projects.neocollege.studyCaseUrl"),
                        "_blank",
                      )
                    }
                  >
                    {t("projects.studyCase")}
                  </button>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      openModal(projectImages.neocollege);
                    }}
                  >
                    {t("projects.screenshots")}
                  </button>
                </ContainerLink>
              </Overlay>
            )}
            <img src="/cardNeocollege.png" alt="Neocollege Card" />
          </EmblaSlide>

          {/* Budget */}
          <EmblaSlide
            isActive={selectedIndex === 4}
            hasOverlay={overlay === "budget"}
            onClick={() => handleClickSlide(4, "budget")}
          >
            <MoreInfoButton onClick={(e) => handleOverlay(e, "budget")}>
              {overlay === "budget" ? (
                <IoMdClose size={32} />
              ) : (
                <IoMdInformation />
              )}
            </MoreInfoButton>
            {overlay === "budget" && (
              <Overlay>
                <ContainerDescription>
                  {t("projects.budget.description")}
                </ContainerDescription>
                <ContainerLink>
                  <button
                    onClick={() =>
                      window.open(
                        "https://github.com/FabienD0/Budget-MobileApp",
                        "_blank",
                      )
                    }
                  >
                    {t("projects.github")}
                  </button>
                </ContainerLink>
              </Overlay>
            )}
            <img src="/cardBudget.png" alt="Budget Card" />
          </EmblaSlide>

          {/* Pokemon World */}
          <EmblaSlide
            isActive={selectedIndex === 5}
            hasOverlay={overlay === "pokemon"}
            onClick={() => handleClickSlide(5, "pokemon")}
          >
            <MoreInfoButton onClick={(e) => handleOverlay(e, "pokemon")}>
              {overlay === "pokemon" ? (
                <IoMdClose size={32} />
              ) : (
                <IoMdInformation />
              )}
            </MoreInfoButton>
            {overlay === "pokemon" && (
              <Overlay>
                <ContainerDescription>
                  <p>{t("projects.pokemon.description")}</p>
                </ContainerDescription>
                <ContainerLink>
                  <button
                    onClick={() =>
                      window.open(
                        "https://pokemonworldgame.netlify.app/",
                        "_blank",
                      )
                    }
                  >
                    {t("projects.live")}
                  </button>
                  <button
                    onClick={() =>
                      window.open(
                        "https://github.com/FabienD0/Pokemon-World",
                        "_blank",
                      )
                    }
                  >
                    {t("projects.github")}
                  </button>
                </ContainerLink>
              </Overlay>
            )}
            <img src="/cardPokemonWorld.png" alt="Pokemon World Card" />
          </EmblaSlide>
        </EmblaContainer>
      </EmblaViewport>
      {/* END EMBLA CAROUSEL */}

      <img
        src="/AboutWave.svg"
        alt="Wave About"
        style={{ position: "absolute", top: "300px", right: 0, zIndex: -1 }}
      />

      {modal.images.length > 0 && (
        <ModalBackdrop onClick={closeModal}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            <ModalClose onClick={closeModal}>
              <IoMdClose size={32} />
            </ModalClose>
            <ModalArrow side="left" onClick={prevImage}>
              <AiOutlineArrowLeft />
            </ModalArrow>
            <img src={modal.images[modal.index]} alt="Preview" />
            <ModalArrow side="right" onClick={nextImage}>
              <AiOutlineArrowRight />
            </ModalArrow>
            <ModalCounter>
              {modal.index + 1} / {modal.images.length}
            </ModalCounter>
          </ModalContent>
        </ModalBackdrop>
      )}
    </MainContainer>
  );
};

export default Projects;

/* ─── Embla structure ─── */

const EmblaViewport = styled.div`
  overflow: hidden;
  width: 100%;
  position: relative;
  background-color: ${colors.primary100};
`;

const EmblaContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  padding: 2rem 0 3.5rem;
  user-select: none;
  -webkit-user-select: none;
`;

const EmblaSlide = styled.div`
  position: relative;
  flex: 0 0 45rem;
  height: 30rem;
  border-radius: 15px;
  overflow: hidden;
  z-index: 1;
  transition:
    transform 0.5s ease,
    filter 0.5s ease,
    opacity 0.5s ease;
  transform: scale(${(props) => (props.isActive ? 1 : 0.85)});
  filter: blur(${(props) => (props.isActive ? "0px" : "2.5px")});
  opacity: ${(props) => (props.isActive ? 1 : 0.6)};
  cursor: pointer;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: fill;
    border-radius: 15px;
    pointer-events: none;
  }

  @media (max-width: 850px) {
    flex: 0 0 80vw;
    height: 22rem;
  }

  @media (max-width: 500px) {
    flex: 0 0 88vw;
    height: 18rem;
  }
`;

/* ─── Layout ─── */

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  isolation: isolate;
  background-color: ${colors.primary100};
  min-height: 55rem;

  @media only screen and (max-height: 1907px) and (pointer: coarse) {
    height: auto;
  }
`;

const Container = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 70%;

  @media (max-width: 1150px) {
    width: 80%;
  }
`;

const ContainerTitle = styled.div`
  margin-top: 5rem;
  width: fit-content;
  position: relative;
  z-index: 2;

  @media (max-width: 880px) {
    margin-bottom: 2rem;
  }
`;

const H1 = styled.h1`
  color: #0f2c36;
  font-size: 42px;
  font-weight: 700;

  @media (max-width: 450px) {
    font-size: 34px;
  }
`;

const LineTitle = styled.div`
  position: absolute;
  bottom: 0;
  opacity: 65%;
  height: 20px;
  width: 105%;
  left: 50%;
  transform: translateX(-50%);
  background-color: ${colors.secondary};
  border-radius: 15px;
  z-index: -1;
`;

const ContainerArrow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 1rem;
`;

const ContainerArrowLeft = styled.button`
  all: unset;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 3.5rem;
  width: 3.5rem;
  border-radius: 50%;
  color: ${colors.secondary};
  background-color: transparent;
  font-size: 28px;
  border: 2px solid ${colors.secondary};
  transition: all 0.3s;

  &:hover {
    border: 2px solid transparent;
    background-color: ${colors.secondary};
    color: ${colors.white};
    cursor: pointer;
  }

  @media (max-width: 850px) {
    height: 2.5rem;
    width: 2.5rem;
    font-size: 20px;
  }
`;

const ContainerArrowRight = styled.button`
  all: unset;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 3.5rem;
  width: 3.5rem;
  border-radius: 50%;
  color: ${colors.white};
  font-size: 28px;
  background-color: ${colors.secondary};
  border: 2px solid transparent;
  transition: all 0.3s;

  &:hover {
    cursor: pointer;
  }

  @media (max-width: 850px) {
    height: 2.5rem;
    width: 2.5rem;
    font-size: 20px;
  }
`;

/* ─── Overlay ─── */

const Overlay = styled.div`
  position: absolute;
  background-color: black;
  opacity: 90%;
  border-radius: 15px;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 2rem;
  z-index: 10;

  @media (max-width: 850px) {
    padding: 1rem;
  }
`;

const MoreInfoButton = styled.button`
  all: unset;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background-color: ${colors.primary};
  border: 1px solid transparent;
  font-size: 48px;
  color: ${colors.primary400};
  right: 20px;
  bottom: 30px;
  transition: all 0.3s;
  z-index: 22;
  opacity: 0.6;

  @media (max-width: 850px) {
    width: 2rem;
    height: 2rem;
    font-size: 32px;
    right: 10px;
    bottom: 15px;
  }

  &:hover {
    cursor: pointer;
    border: 1px solid ${colors.primary400};
    opacity: 1;
  }
`;

const ContainerDescription = styled.div`
  color: ${colors.white};
  font-family: "Open Sans";
  text-align: left;
  font-size: 18px;
  font-weight: 400;
  line-height: normal;
  white-space: pre-wrap;

  @media (max-width: 850px) {
    font-size: 12px;
  }
`;

const ContainerLink = styled.div`
  color: ${colors.primary};
  font-family: "Open Sans";
  text-align: center;
  font-size: 32px;
  font-weight: 900;
  line-height: normal;
  margin-top: 2rem;
  white-space: nowrap;

  @media (max-width: 850px) {
    font-size: 14px;
    margin-top: 0.75rem;
  }

  button {
    all: unset;
    border: 2px solid ${colors.primary};
    border-radius: 15px;
    margin: 0 0.5rem;
    transition: all 0.3s;
    width: fit-content;
    padding: 0.5rem 1rem;

    @media (max-width: 850px) {
      margin: 0 0.25rem;
      padding: 0.3rem 0.6rem;
      border-radius: 10px;
    }

    &:hover {
      color: ${colors.primary400};
      background-color: ${colors.primary};
      border: 2px solid transparent;
      cursor: pointer;
    }
  }
`;

/* ─── Screenshot Modal ─── */

const ModalBackdrop = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const ModalContent = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 90vw;
  max-height: 90vh;

  img {
    display: block;
    max-width: 80vw;
    max-height: 85vh;
    border-radius: 12px;
    object-fit: contain;
  }
`;

const ModalClose = styled.button`
  all: unset;
  position: absolute;
  top: -2.5rem;
  right: 0;
  color: ${colors.white};
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 0.2s;

  &:hover {
    opacity: 1;
  }
`;

const ModalArrow = styled.button`
  all: unset;
  position: absolute;
  ${(props) => (props.side === "left" ? "left: -3.5rem;" : "right: -3.5rem;")}
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.75rem;
  height: 2.75rem;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.15);
  color: ${colors.white};
  font-size: 22px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(255, 255, 255, 0.35);
  }

  @media (max-width: 600px) {
    ${(props) => (props.side === "left" ? "left: -2rem;" : "right: -2rem;")}
    width: 2rem;
    height: 2rem;
    font-size: 16px;
  }
`;

const ModalCounter = styled.div`
  position: absolute;
  bottom: -2rem;
  left: 50%;
  transform: translateX(-50%);
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  font-family: "Open Sans";
`;
